module.exports = "//a.spikex.com/sigma/frontend-ssr-web-index/_next/static/images/nft-2-8679eb4bef47738f851cc169e0e8184b.png";